export const LARGE_SCREEN = 992